/**
 * PopulationStep.tsx — step 1 of the VER-128 Create Programme preview: "Who are you working
 * with?" No Prisma field backs this selection yet (see createProgramme.types.ts); it is kept
 * in local stepper state only.
 */
import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { POPULATION_OPTIONS } from "./createProgramme.mock";
import { POPULATION_ICONS } from "./createProgramme.icons";
import { PopulationKey } from "./createProgramme.types";
import { SelectableOptionCard } from "./SelectableOptionCard";

type PopulationStepProps = {
    value: PopulationKey;
    onChange: (value: PopulationKey) => void;
};

export const PopulationStep: React.FC<PopulationStepProps> = ({ value, onChange }) => {
    return (
        <Stack spacing={3.5}>
            <Stack spacing={1}>
                <Typography variant="overline" color="primary.main">
                    Step 1 of 4
                </Typography>
                <Typography variant="h3" component="h2" color="secondary.main">
                    Who are you working with?
                </Typography>
                <Typography variant="body1" color="secondary.dark" sx={{ lineHeight: 1.6 }}>
                    Choose the population group. This determines the assessment approach, story collection and session
                    structure.
                </Typography>
            </Stack>

            <Grid container spacing={2}>
                {POPULATION_OPTIONS.map((option) => (
                    <Grid item xs={12} sm={6} md={4} key={option.key}>
                        <SelectableOptionCard
                            title={option.title}
                            subtitle={option.subtitle}
                            body={option.body}
                            icon={POPULATION_ICONS[option.key]}
                            selected={value === option.key}
                            onClick={() => onChange(option.key)}
                        />
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};
